module.exports = __webpack_public_path__ + "img/bg1.7415c91d.png";